import { create } from "zustand";

export const useStoreNetwork = create((set) => ({
  networks: [],
  setNetworks: (networks) => set({ networks }),
  isLoaded: false,
  setIsLoaded: (isLoaded) => set({ isLoaded }),
}));